"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../../primitives/Icons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CallOut = _ref => {
  let {
    children,
    icon = 'zap',
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-callout".concat(className ? ' ' + className : '')
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: icon
  }), children);
};
var _default = exports.default = CallOut;